import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { QuizQuestion } from '@app/store/quiz-questions/models/quiz-question';

@Component({
    selector: 'app-quiz-question-list',
    templateUrl: './question-list.component.html',
    styleUrls: ['./question-list.component.css'],
    imports: [TranslateModule, ButtonModule, CdkDropList, CdkDrag],
})
export class QuestionListComponent {
    readonly questions = input.required<QuizQuestion[]>();
    readonly loading = input(false);
    readonly testId = input.required<string>();

    readonly add = output<void>();
    readonly remove = output<number>();
    readonly reorder = output<QuizQuestion[]>();

    moveQuestion(index: number, direction: -1 | 1): void {
        const questions = [...this.questions()];
        moveItemInArray(questions, index, index + direction);
        this.reorder.emit(questions);
    }

    onDrop(event: CdkDragDrop<QuizQuestion[]>): void {
        const questions = [...this.questions()];
        moveItemInArray(questions, event.previousIndex, event.currentIndex);
        this.reorder.emit(questions);
    }
}
